import { Group, Paper, Stack, Text, Title } from '@mantine/core'

import { UserManagement } from '../UserManagementScreen/UserManagement'

interface CustomerRepsPanelProps {
  showTutorialText: boolean
}

export function CustomerRepsPanel({ showTutorialText = false }: CustomerRepsPanelProps) {
  return (
    <Stack>
      <Paper radius="md" p="lg" shadow="sm" px="xl">
        <Group justify="space-between" mb="md">
          <Title order={4}>Invite Program Managers</Title>
        </Group>

        {showTutorialText && (
          <Text size="md" c="dimmed" mb="md">
            Invite additional program managers from your organization to help setup the Sidekick Platform, adjust
            settings, invite experts and end users, and create content modules for Expert Sidekicks.
          </Text>
        )}

        <UserManagement role="Admin" showRoleColumn={false} entityName="Program Manager" />
      </Paper>
    </Stack>
  )
}
